module.exports = __webpack_public_path__ + "inner-banner.a9d1f9d9d2cb5a2f717c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inner-banner.png
// module id = 846
// module chunks = 15